import { getMembershipPropertiesAsync } from './getMembershipPropertiesAsync'

export const isPartnershipUserAsync = async (refresh = false) => {
  const { paymentGatewayUserProduct: partnerships } =
    await getMembershipPropertiesAsync(refresh)

  return !!partnerships
}
